
import { StyleColorSchemeType, StyleFontWeightType } from '../../styles/enums';
import Dropdown from '../dropdown';
import Select from '../select';
import MinMaxSelectProps from './mixins/MinMaxSelectProps';
import {
  MinMaxSelectEventType,
  MinMaxSelectId,
  MinMaxSelectProperty,
  MinMaxSelectVariant,
} from './enums';
import SelectOptionsMixin from '../../mixins/select-options';
import { TypographyProperty, TypographyType } from '@/ui-kit/components/typography/enums';
import Typography from '@/ui-kit/components/typography';

export default {
  name: 'MinMaxSelect',
  components: {
    Dropdown,
    Select,
    Typography,
  },
  mixins: [SelectOptionsMixin, MinMaxSelectProps],
  data() {
    return {
      StyleColorSchemeType,
      MinMaxSelectProperty,
      TypographyProperty,
      TypographyType,
      StyleFontWeightType,
    };
  },
  computed: {
    isDropdownVariant() {
      return this[MinMaxSelectProperty.Variant] === MinMaxSelectVariant.Dropdown;
    },
    convertedToObjectMinOptions() {
      return this.getConvertedOptions(this.minValues);
    },
    convertedToObjectMaxOptions() {
      return this.getConvertedOptions(this.maxValues);
    },
    minOptionsValues() {
      return this.convertedToObjectMinOptions.map((option) => option.value);
    },
    maxOptionsValues() {
      return this.convertedToObjectMaxOptions.map((option) => option.value);
    },
    greatestMaxOption() {
      return Math.max(...this.maxOptionsValues);
    },
    smallestMinOption() {
      return Math.min(...this.minOptionsValues);
    },
    filteredMinSelectOptions() {
      return this.convertedToObjectMinOptions
        .filter((option) => option.value < (this.value.max || this.greatestMaxOption));
    },
    filteredMaxSelectOptions() {
      return this.convertedToObjectMaxOptions
        .filter((option) => option.value > (this.value.min || this.smallestMinOption));
    },
    minValueOption() {
      return this.getOptionByValue(this.value.min, this.convertedToObjectMinOptions);
    },
    maxValueOption() {
      return this.getOptionByValue(this.value.max, this.convertedToObjectMaxOptions);
    },
    placeholder() {
      if (!this.minValueOption || !this.maxValueOption) {
        return '';
      }

      return `${this.minValueOption?.text || '?'} - ${this.maxValueOption?.text || '?'}`;
    },
  },
  methods: {
    handleMinSelectChange(value) {
      this.$emit(
        MinMaxSelectEventType.Change,
        {
          ...this.value,
          min: value,
          action: MinMaxSelectId.Min,
        },
      );
    },
    handleMaxSelectChange(value) {
      this.$emit(
        MinMaxSelectEventType.Change,
        {
          ...this.value,
          max: value,
          action: MinMaxSelectId.Max,
        },
      );
    },
  },
};
